import { EInvoiceStatus } from '../enums/invoices.enum';

export const InvoicesStatus = {
    [EInvoiceStatus.ACTIVE]: 'ACTIVE',
    [EInvoiceStatus.PENDING]: 'APPROVED',
    [EInvoiceStatus.PAYED]: 'PAID',
    [EInvoiceStatus.UNCOLLECTIBLE]: 'UNCOLLECTIBLE',
    [EInvoiceStatus.CLOSED]: 'CLOSED',
};

export const ChangeInvoiceStatus = {
    [EInvoiceStatus.PENDING]: 'APPROVED',
    [EInvoiceStatus.PAYED]: 'PAID',
    [EInvoiceStatus.UNCOLLECTIBLE]: 'UNCOLLECTIBLE',
    [EInvoiceStatus.CLOSED]: 'CLOSED',
};
